function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Holds information of a products mapping to his backend structure and includes his HTMLNode reference.
 * Most of the information is retrieved from the product HTMLNode
 *
 * @param {int} id Id of the product
 * @param {string} image Url of the product image
 * @param {string} name Name of the product (also know an title)
 * @param {string} description Description of the product
 * @private
 */
var Product = /*#__PURE__*/function () {
  /**
   * @param {Element} productDom HTML Element of the product
   * @param {int} initialAmount The initial amount of the product
   */
  function Product(productDom) {
    var initialAmount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    _classCallCheck(this, Product);
    this.productDom = productDom;
    this.initialAmount = initialAmount;
    this.id = productDom.getAttribute('data-product-id');
    this.image = productDom.querySelector('.product__image > img').getAttribute('src');
    this.name = productDom.querySelector('.product__headline > h4').innerHTML;
    this.description = productDom.querySelector('.product__description').innerHTML;

    // Call initialing events
    this.addEvents();
  }

  /**
   * Adds events to the increase/decrease icons of the amount for the product box
   * @private
   */
  return _createClass(Product, [{
    key: "addEvents",
    value: function addEvents() {
      // For now just add the elements with JS
      var productAmount = this.productDom.querySelector('.product__amount');
      var inputAmount = productAmount.querySelector('input');
      productAmount.querySelector('.increase-amount').addEventListener('click', function () {
        // inputAmount.stepUp(); // TODO: Refactor this shit
        if (inputAmount.getAttribute('max') !== null) {
          inputAmount.value = parseInt(inputAmount.value, 10) + 1 > parseInt(inputAmount.getAttribute('max'), 10) ? inputAmount.value : (parseInt(inputAmount.value, 10) + 1).toString();
        } else {
          inputAmount.value = (parseInt(inputAmount.value, 10) + 1).toString();
        }
      });
      productAmount.querySelector('.decrease-amount').addEventListener('click', function () {
        // inputAmount.stepDown();
        if (inputAmount.getAttribute('min') !== null) {
          inputAmount.value = parseInt(inputAmount.value, 10) - 1 < parseInt(inputAmount.getAttribute('min'), 10) ? inputAmount.value : (parseInt(inputAmount.value, 10) - 1).toString();
        } else {
          inputAmount.value = (parseInt(inputAmount.value, 10) - 1).toString();
        }
      });
    }

    /**
     * Gets the selected amount of the product.
     *
     * @returns {number} Selected amount of the product
     */
  }, {
    key: "getSelectedAmount",
    value: function getSelectedAmount(itemId) {
      var element = document.querySelectorAll(".product[data-product-id=\"".concat(itemId, "\"]"));
      var amountVal = 0;
      element.forEach(function (product) {
        amountVal += parseInt(product.querySelector('.product__amount input').value, 10);
      });
      return amountVal;
    }

    /**
     * Sets the selected amount of the product
     *
     * @param {int} newAmount It has to be a positive number, to set as amount selected of product
     * @returns {boolean|int} Returns the new amount of the product, or FALSE if the @newAmount is invalid
     */
  }, {
    key: "setSelectedAmount",
    value: function setSelectedAmount(newAmount) {
      if (!Number.isNaN(newAmount) && newAmount >= 0) {
        this.productDom.querySelector('.product__amount > input').value = newAmount;
        return this.productDom.querySelector('.product__amount > input').value;
      }
      return false;
    }

    /**
     * This function is just a wrapper for setSelectedAmount to reset the amount to the defined @initialAmount value
     */
  }, {
    key: "resetSelectedAmount",
    value: function resetSelectedAmount() {
      this.setSelectedAmount(this.initialAmount);
    }
  }]);
}();
export default Product;